<template>
  <div class="flow-padding-bottom zero-top w-100pc flow-flex-col w3-left">
    <label class="w3-left flow-main-color flow-padding-bottom">{{
      $t(labelName)
    }}</label>
    <input
      v-show="!isDisabled"
      class="w3-input w3-border w3-round-medium"
      v-bind:type="isNumber ? 'number' : 'text'"
      v-model="safeModelText"      
      v-bind:placeholder="placeholder"
    />
    <input
      v-show="isDisabled"
      class="w3-input w3-border w3-round-medium"
      type="text"
      v-model="safeModelText"
      v-bind:placeholder="placeholder"
      disabled
    />
    <span class="w3-text-red">{{ npNameError }}</span>
  </div>
</template>
<script>
export default {
  name: "StandardTextBox",
  emits: ["update:modelText"],
  props: {
    npNameError: {
      type: String,
      required: false,
      default: "",
    },
    isDisabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    modelText: {
      type: String,
      required: false,
      default: "",
    },
    placeholder: {
      type: String,
      required: false,
      default: "",
    },
    labelName: {
      type: String,
      required: false,
      default: "",
    },
    isNumber: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
    };
  },
  computed: {
    safeModelText: {
      get() {
        return this.modelText ?? '';
      },
      set(newValue) {
        this.$emit('update:modelText', newValue ?? '');
      }
    }
  },
  // methods: {
  //   updateText(event) {
  //     const newValue = event.target.value ?? '';
  //     this.$emit("update:modelText", newValue);
  //   },
  // },
};
</script>
